import React from "react";
//#region redux
//#endregion
//#region types
import { TranslationKeys } from "translations";
import { IconDefinitionConstants } from "utils/constants";
import { WintSuperkollAPIModel } from "wint-api-client/dist/types";
import { SelfInvoiceBannerProps } from "models/propTypes/selfInvoicePropTypes";
//#endregion
//#region components
import { Banner, StyledButton } from "components/common";
import { useNavigate, useLocation } from "react-router";
//#endregion
import { LocalizationHelperInstance, UrlHelper } from "utils/helpers";

const SelfInvoiceBanner: React.FC<SelfInvoiceBannerProps> = ({ selfInvoice, displayType, relatedInvoiceId }) => {
  const location = useLocation();
  const navigate = useNavigate();

  const onViewInvoice = () => {
    navigate(UrlHelper.formatPath(`/Invoice/${relatedInvoiceId}`), {
      state: { background: location },
    });
  };

  const getTitle = () => {
    let title = LocalizationHelperInstance.getFormattedMessage(
      TranslationKeys.DocumentDraft.CreatedSelectionPanelSelfInvoiceHeaderText
    );

    if (selfInvoice?.state === WintSuperkollAPIModel.SelfInvoiceState.Unhandled) {
      title = title.concat(
        ` ${LocalizationHelperInstance.getFormattedMessage(
          TranslationKeys.DocumentDraft.CreatedSelectionPanelSelfInvoiceHeaderSubText
        )}`
      );
    } else if (selfInvoice?.state === WintSuperkollAPIModel.SelfInvoiceState.Rejected) {
      return LocalizationHelperInstance.getFormattedMessage(
        TranslationKeys.DocumentDraft.RemovedSelectionPanelSelfInvoiceHeaderText
      );
    } else if (selfInvoice?.state === WintSuperkollAPIModel.SelfInvoiceState.Deleted) {
      return LocalizationHelperInstance.getFormattedMessage(TranslationKeys.DocumentDraft.DocumentDeletedDescription);
    }

    return title;
  };

  return (
    <Banner title={getTitle()} icon={IconDefinitionConstants.WInfo} type={displayType}>
      {relatedInvoiceId && (
        <StyledButton size="sm" displayType={displayType} onClick={onViewInvoice}>
          {LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Quotation.ViewInvoice)}
        </StyledButton>
      )}
    </Banner>
  );
};

export default SelfInvoiceBanner;
